export default __webpack_public_path__ + "static/phone-72gtg-46ea280047578f37940f3af58840109f.jpg";